export const deleteTask = (payload?: any) => ({
    type: "@saga/DELETE_COURSE_TASK",
    payload
});

